import styled from 'styled-components';

import { adSlotConfig } from '../../ad-slot-config';
import { useDefineSlot } from '../../hooks/use-define-slot';

const AdContainer = styled.div`
  min-height: 90px;
  max-height: 250px;
  margin: 0 auto;
`;

export const DisplayAdLogoutBillboard: React.FC<{
  refresh: boolean;
}> = ({ refresh }) => {
  const slotConfig = adSlotConfig.Logout.Billboard;
  useDefineSlot({ ...slotConfig, refresh });

  return <AdContainer id={slotConfig.id} />;
};
